DataDefinitionQueryOptionsFactory.$inject = [];
export default function DataDefinitionQueryOptionsFactory() {
	function DataDefinitionRequestOptions(options = {}) {
		const availableOptions = [
			'entityClassName',
			'objectIDs',
			'excludedIDs',
			'useObjectId',
			'columnDefinition',
			'filter',
			'correctEntityFilter',
			'allowedTypes',
			'relationName',
			'archived',
			'fragmentId',
			'lookupFor',
			'resetFilter',
			'returnNoItems',
		];

		availableOptions.forEach((option) => {
			let optionValue = options[option];
			Object.defineProperty(this, option, {
				enumerable: true,
				get: function () {
					return optionValue;
				},
				set: function (newValue) {
					optionValue = newValue;
				},
			});
		});

		Object.freeze(this);
	}

	return DataDefinitionRequestOptions;
}
